import { useCallback } from 'react';
import { useFetchCampaignsAssociationSettings, hasCampaignsReadAccess } from './useFetchCampaignsAssociationSettings';
import { useCampaignsContext } from '../CampaignsProvider';
import unescapedText from 'I18n/utils/unescapedText';
export function useCampaignsPlatformEditAction({
  objectType,
  assetId,
  crmIdProperty = 'hs_object_id'
}) {
  const {
    data: associationSettings,
    loading: associationSettingsLoading
  } = useFetchCampaignsAssociationSettings();
  const {
    showEditCampaignActionModal
  } = useCampaignsContext();
  const onCampaignEdit = useCallback(() => {
    showEditCampaignActionModal({
      objectType,
      assetId,
      crmIdProperty
    });
  }, [assetId, crmIdProperty, objectType, showEditCampaignActionModal]);
  return {
    onCampaignEdit,
    editActionText: unescapedText('campaignSelect.editCampaign'),
    isDisabled: associationSettingsLoading || !associationSettings || !associationSettings[objectType] || !hasCampaignsReadAccess(associationSettings, objectType)
  };
}